import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { WorkerPool } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';
import type { PaginationMeta } from '@recruitee/http-types';
import { tableDataDefaultParams } from '@recruitee/referrals-types';
import type {
  ReferralReward,
  ReferralRewardCreate,
  TableDataParams,
} from '@recruitee/referrals-types';

@Injectable({ providedIn: 'root' })
export class RewardHttpClient {
  constructor(
    private httpApi: HttpApiService,
    private workerPool: WorkerPool,
  ) {}

  public createReward(data: ReferralRewardCreate): Observable<ReferralReward> {
    return this.httpApi
      .post(`/referral/rewards`, null, { reward: data })
      .pipe(map(data => data.reward));
  }

  public updateReward({
    id,
    data,
  }: {
    id: number;
    data: ReferralRewardCreate;
  }): Observable<ReferralReward> {
    return this.httpApi
      .patch(`/referral/rewards/${id}`, null, { reward: data })
      .pipe(map(data => data.reward));
  }

  public loadRewards(
    params?: TableDataParams,
  ): Observable<{ rows: ReferralReward[]; meta: PaginationMeta }> {
    return this.httpApi.get(`/referral/rewards`, { ...tableDataDefaultParams, ...params }).pipe(
      switchMap(data =>
        this.workerPool.fillInReferences(data.rewards, data.references).pipe(
          map((rows: ReferralReward[]) => ({
            meta: data.meta,
            rows: rows,
          })),
        ),
      ),
    );
  }

  public deleteReward(ids: number[]): Observable<any> {
    return this.httpApi.post(
      '/referral/rewards/delete_all',
      {},
      {
        rewards_ids: ids,
      },
    );
  }
}
